import script from "./MarkupDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkupDrawer.vue?vue&type=script&setup=true&lang=js"

import "./MarkupDrawer.vue?vue&type=style&index=0&id=0f4b2cfc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f4b2cfc"]])

export default __exports__